import type { ReactNode } from 'react';
import { Box, Button, Card, FormButtonRow, Heading, SuccessAnimation, Text } from '@ksyos/design-system';
import { useNavigate } from '@ksyos/router';

interface IKgbSuccessPageProps {
    buttonText?: string;
    linkTo?: string;
    summaryCard?: JSX.Element;
    text: ReactNode;
    title?: string;
}

export function KgbSuccessPage(props: IKgbSuccessPageProps) {
    const navigate = useNavigate();

    return (
        <Box
            alignItems="center"
            display="flex"
            flexDirection="column"
            justifyContent="center"
            minHeight={'calc(100vh - 120px)'}
        >
            <Card>
                <Card.Body>
                    <Box
                        alignItems="center"
                        display="flex"
                        flexDirection="column"
                        sx={{
                            maxInlineSize: '60ch',
                        }}
                    >
                        <SuccessAnimation size="large" />
                        {props.title && (
                            <Heading
                                mb={6}
                                size="xlarge"
                            >
                                {props.title}
                            </Heading>
                        )}
                        <Text textAlign="center">{props.text}</Text>
                    </Box>

                    {props.buttonText && props.linkTo && (
                        <FormButtonRow justify="center">
                            <Button
                                color="primary"
                                onClick={() => {
                                    if (props.linkTo) {
                                        navigate(props.linkTo);
                                    }
                                }}
                                width="full-below-small"
                            >
                                {props.buttonText}
                            </Button>
                        </FormButtonRow>
                    )}
                </Card.Body>
            </Card>
            {props.summaryCard}
        </Box>
    );
}
